import { AncientQuery } from '../types/oracle';

export const ancientQueries: AncientQuery[] = [
  // Authentic ancient oracle consultation patterns
  {
    id: 'household',
    text: 'To which of the gods should I pray concerning my household and safety?',
    category: 'Household & Safety',
    origin: 'authentic'
  },
  {
    id: 'family',
    text: 'Concerning the safety of the child and the wife: what should be done?',
    category: 'Safety of Family',
    origin: 'authentic'
  },
  {
    id: 'prosperity',
    text: 'To which of the gods am I to sacrifice and pray, in order that I may prosper?',
    category: 'Success / Which god',
    origin: 'authentic'
  },
  {
    id: 'lawsuit',
    text: 'Concerning the lawsuit: what should be done?',
    category: 'Legal Dispute',
    origin: 'authentic'
  },
  {
    id: 'health',
    text: 'Concerning my body: what should I do to be in good health?',
    category: 'Health',
    origin: 'authentic'
  },
  {
    id: 'business',
    text: 'Concerning a business undertaking: what is more advantageous and better?',
    category: 'Business',
    origin: 'authentic'
  },
  {
    id: 'freedom',
    text: 'Concerning the manumission of a slave: what is better and more advantageous?',
    category: 'Manumission',
    origin: 'authentic'
  },
  {
    id: 'victory',
    text: 'Shall I win the lawsuit?',
    category: 'Legal Victory',
    origin: 'authentic'
  },
  {
    id: 'children',
    text: 'Concerning progeny: To which of the gods should I pray or offer sacrifice, so that children may be born?',
    category: 'Fertility',
    origin: 'authentic'
  },
  {
    id: 'travel',
    text: 'Concerning a journey: is it safe? What is preferable?',
    category: 'Travel Safety',
    origin: 'authentic'
  },
  {
    id: 'marriage',
    text: 'Whether it has been granted to me to marry. Grant me this.',
    category: 'Marriage',
    origin: 'authentic'
  },
  {
    id: 'healing',
    text: 'If you permit me to consult the physician for treatment of the eyes, and this is to my advantage, grant me this.',
    category: 'Medical Consultation',
    origin: 'authentic'
  },

  // Generated queries inspired by Orphic themes
  {
    id: 'purification',
    text: 'How shall I purify myself of what weighs upon my spirit?',
    category: 'Purification',
    origin: 'generated'
  },
  {
    id: 'afterlife',
    text: 'What must I remember when I stand before the waters of forgetfulness?',
    category: 'Death & Rebirth',
    origin: 'generated'
  },
  {
    id: 'initiation',
    text: 'Am I prepared to undergo the rites, or must I wait?',
    category: 'Initiation',
    origin: 'generated'
  },
  {
    id: 'cosmic-order',
    text: 'What is my portion in the order of things?',
    category: 'Cosmic Order',
    origin: 'generated'
  },
  {
    id: 'divine-anger',
    text: 'Have I offended the gods, and how shall I make amends?',
    category: 'Divine Wrath',
    origin: 'generated'
  },
  {
    id: 'protection-stone',
    text: 'Which stone should I carry for protection on the road ahead?',
    category: 'Sacred Stones',
    origin: 'generated'
  },
  {
    id: 'transformation',
    text: 'I feel myself changing. What am I becoming?',
    category: 'Transformation',
    origin: 'generated'
  },
  {
    id: 'night-terrors',
    text: 'What sends the visions that trouble my sleep, and how do I appease it?',
    category: 'Dreams & Spirits',
    origin: 'generated'
  },
  {
    id: 'fate',
    text: 'Is my fate already woven, or may I yet change its pattern?',
    category: 'Fate & Destiny',
    origin: 'generated'
  },
  {
    id: 'lost-soul',
    text: 'One I loved has departed. Can anything reach them where they have gone?',
    category: 'The Dead',
    origin: 'generated'
  },
  {
    id: 'right-action',
    text: 'Two paths lie before me and both seem just. Which does Dikē favor?',
    category: 'Justice',
    origin: 'generated'
  },
  {
    id: 'divine-sign',
    text: 'I have seen a sign but cannot read it. What does it portend?',
    category: 'Omens',
    origin: 'generated'
  }
];
